"use client";
import React from "react";
import Map3 from "../Images/CCA-Abstract-Shapes-08.jpg";
function MapBanner() {
  const features = [
    "Online Platforms",
    "Preparation of Documents",
    "User-Friendly Interfaces",
    "Data Import and Prefill Features",
    "Prompt Assistance and Support",
    "Regular Updates and Compliance",
  ];

  return (
    <section className="map-banner">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT CONTENT */}
          <div className="col-lg-6">
            <div className="content-box">
              <h2 className="fw-bold" style={{ color: "#115886" }}>
                Effortless <span>E-Filing</span> of Income Tax Returns
              </h2>
              <div className="timeline">
                {features.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <div className="dot"></div>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* RIGHT IMAGE */}
          <div className="col-lg-6 text-center">
            <div className="image-wrapper">
              <img src={Map3} alt="banner" className="img-fluid banner-img" />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .map-banner {
          background: linear-gradient(135deg, #eef2ff, #f8fbff);
        }
        .heading {
          font-size: 38px;
          font-weight: 800;
          line-height: 1.3;
        }
        .sub-text {
          margin-top: 15px;
          color: #6b7280;
          font-size: 16px;
        }

        /* Timeline */
        .timeline {
          margin-top: 30px;
        }

        .timeline-item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          position: relative;
          padding-left: 30px;
        }

        .timeline-item .dot {
          position: absolute;
          left: 0;
          width: 12px;
          height: 12px;
          background: linear-gradient(135deg, #115886, #06b6d4);
          border-radius: 50%;
        }

        .timeline-item::before {
          content: "";
          position: absolute;
          left: 5px;
          top: 18px;
          width: 2px;
          height: 100%;
          background: #ddd;
        }

        .timeline-item:last-child::before {
          display: none;
        }

        /* Image Clean Style */
        .banner-img {
          border-radius: 20px;
          transition: 0.4s;
        }

        .banner-img:hover {
          transform: scale(1.05);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .heading {
            font-size: 26px;
          }

          .image-wrapper {
            margin-top: 30px;
          }
        }
      `}</style>
    </section>
  );
}

export default MapBanner;